<script>
export default {
  props: {
    placeholder: { type: String, required: false },
    label: { type: String, required: true },
    value: { type: String, required: false, default: '' },
    name: { type: String, required: true },
    readonly: { type: Boolean, default: false },
    maxlength: { type: Number, default: 524288 },
    singleLineScroll: { type: Boolean, default: false },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    active() {
      return this.focused;
    },
    hasText() {
      return Boolean(this.value);
    },
    placeholderText() {
      return this.focused ? '' : this.placeholder;
    },
  },
  methods: {
    onInputFocus() {
      this.focused = true;
      this.$emit('focus');
    },
    onInputBlur() {
      this.focused = false;
      if (!this.value) {
        this.$refs.input.style.height = null;
      }
      this.$emit('blur');
    },
    /**
     * This function exists so you can easily call blur on the component
     */
    blur() {
      this.$refs.input.blur();
      this.onInputBlur();
    },
    focus() {
      this.onInputFocus();
    },
    onInput(e) {
      this.$emit('input', e.target.value);
      if (this.singleLineScroll) {
        const textarea = e.target;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
        return;
      }
      const currentHeight = e.target.clientHeight;

      if (currentHeight >= e.target.scrollHeight) {
        return;
      }

      e.target.style.height = '5px';
      e.target.style.height = e.target.scrollHeight + 'px';
    },
  },
};
</script>

<template>
  <div class="lh-input-new" :class="[
    { active: active, 'has-text': hasText, readonly },
    singleLineScroll && 'single-line-scroll',
  ]">
    <label :for="name">{{ label }}</label>
    <textarea
      :id="name"
      ref="input"
      type="text"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholderText"
      :maxlength="maxlength"
      :rows="singleLineScroll ? 1 : undefined"
      @input="e => onInput(e)"
      @focus="onInputFocus"
      @blur="onInputBlur"
      @keyup.stop.prevent.esc="$emit('keyUp', 'esc')"
      @keyup.stop.prevent.enter="$emit('keyUp', 'enter')"
      @keyup.stop.prevent.down="$emit('keyUp', 'down')"
      @keyup.stop.prevent.up="$emit('keyUp', 'up')"
    />
  </div>
</template>
